export const chevron_left = () => (
  <path
    d="M15 18l-6-6 6-6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
